module.exports = __webpack_public_path__ + "img/弱.8b26521b.gif";